import * as React from 'react';

import { RealtorsSection } from 'shared/components/RealtorsSection';
import { useRealtorsArc } from 'shared/hooks';

import realtor1 from 'shared/components/RealtorsSection/assets/realtor-1.jpg';
import realtor2 from 'shared/components/RealtorsSection/assets/realtor-2.jpg';
import realtor3 from 'shared/components/RealtorsSection/assets/realtor-3.jpg';
import realtor4 from 'shared/components/RealtorsSection/assets/realtor-4.jpg';
import realtor5 from 'shared/components/RealtorsSection/assets/realtor-5.jpg';
import realtor6 from 'shared/components/RealtorsSection/assets/realtor-6.jpg';
import realtor7 from 'shared/components/RealtorsSection/assets/realtor-7.jpg';
import realtor8 from 'shared/components/RealtorsSection/assets/realtor-8.jpg';
import realtor9 from 'shared/components/RealtorsSection/assets/realtor-9.jpg';
import realtor10 from 'shared/components/RealtorsSection/assets/realtor-10.jpg';
import { setModalFormOpen } from '../../slices/pageSlice';
import { useDispatch } from 'react-redux';
import { useToggleStickyScrollBtn } from '../../hooks/useToggleStickyScrollBtn';

import { trackCtaClick } from './tracking';

const REALTOR_IMAGES = [
  realtor1,
  realtor2,
  realtor3,
  realtor4,
  realtor5,
  realtor6,
  realtor7,
  realtor8,
  realtor9,
  realtor10,
].join(',');

export const RealtorsSectionContainer: React.FC = () => {
  const arcRef = React.useRef<HTMLDivElement>(null);
  const stickyRef = React.useRef<HTMLDivElement>(null);

  const dispatch = useDispatch();

  useRealtorsArc(arcRef, REALTOR_IMAGES);
  useToggleStickyScrollBtn(stickyRef);

  const handleModalOpenClick = React.useCallback(() => {
    trackCtaClick();
    dispatch(setModalFormOpen('ticket'));
  }, [dispatch]);

  return (
    <RealtorsSection
      arcRef={arcRef}
      stickyRef={stickyRef}
      realtorImages={REALTOR_IMAGES}
      onCtaClick={handleModalOpenClick}
    />
  );
};
